<template>
  <!--  管理员教育机构人才添加进度3-->
  <div class="main-css">
    <div class="main-box">
      <!-- 标题部分 -->
      <div class="top-title">{{ $t("humanResourcesPosting") }}</div>
      <!-- 进度条部分 -->
      <div class="progress-bar">
        <div class="line-between-active"></div>
        <div class="progress-item-active">
          1 <span class="progress-title">{{ $t("basicInformation") }}</span>
        </div>
        <div class="line-center-active"></div>
        <div class="progress-item-active">
          2<span class="progress-title">{{ $t("careerRequest") }}</span>
        </div>
        <div class="line-center-active"></div>
        <div class="progress-item-active">
          3<span class="progress-title">{{ $t("confirm") }}</span>
        </div>
        <div class="line-between-active"></div>
      </div>
      <!--      介绍-->
      <div class="inline-box">
        <div class="one-box-left">
          <div class="one-box-left1">
            <img
              class="Avatar-img"
              :src="avatarUrl"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
          </div>
          <div class="one-box-left2">
            <div class="one-box-left-line1">
              <div class="one-box-left-line-smallLeft">
                <p></p>
              </div>
              <div class="one-box-left-line-smallRight">
                <p>{{ anonym }}</p>
              </div>
            </div>
            <div class="one-box-left-line2">
              <div class="one-box-left-line-smallLeft">
                <p>{{ $t("fullName") }}</p>
              </div>
              <div class="one-box-left-line-smallRight">
                <p>{{ name }}</p>
              </div>
            </div>
            <div class="one-box-left-line3">
              <div class="one-box-left-line-smallLeft">
                <p>{{ $t("sex") }}</p>
              </div>
              <div class="one-box-left-line-smallRight">
                <p>{{ sex }}</p>
              </div>
            </div>
            <div class="one-box-left-line4">
              <div class="one-box-left-line-smallLeft">
                <p>{{ $t("birth") }}</p>
              </div>
              <div class="one-box-left-line-smallRight">
                <p style="width: 290px">{{ birth }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 标签部分 -->
      <div class="label">
        <div
          :class="label1 ? 'label-box-active' : 'label-box'"
          v-if="label1 == 1"
        >
          {{ $t("goodAtJapanese") }}
        </div>
        <div
          :class="label2 ? 'label-box-active' : 'label-box'"
          v-if="label2 == 1"
        >
          {{ $t("qualified") }}
        </div>
        <div
          :class="label3 ? 'label-box-active' : 'label-box'"
          v-if="label3 == 1"
        >
          {{ $t("interviewAtAnytime") }}
        </div>
        <div
          :class="label4 ? 'label-box-active' : 'label-box'"
          v-if="label4 == 1"
        >
          {{ $t("determined") }}
        </div>
      </div>
      <!--      主要信息部分-->
      <div class="main-info-box">
        <!--        第一行-->
        <div class="inline-normal-box">
          <div class="normal-box">
            <div class="normal-top-box-name">{{ $t("contactAddress") }}</div>
            <el-tooltip :content="address" placement="top" v-if="address">
              <div class="normal-bottom-box-name">
                {{ $t("currentAddress") }}: {{ address }}
              </div></el-tooltip
            >

            <el-tooltip :content="email" placement="top" v-if="email">
              <div class="normal-bottom-box-name">
                {{ $t("email") }}: {{ email }}
              </div></el-tooltip
            ><el-tooltip :content="telephone" placement="top" v-if="telephone">
              <div class="normal-bottom-box-name">
                {{ $t("telephoneNumber") }}: {{ telephone }}
              </div></el-tooltip
            >
          </div>
          <div class="normal-box">
            <div class="normal-top-box-name">{{ $t("education") }}</div>
            <el-tooltip
              :content="
                `${enrollment.split(' ')[0]}~${graduation.split(' ')[0]}`
              "
              placement="top"
              v-if="telephone"
            >
              <div class="normal-bottom-box-name">
                {{ $t("period") }}: {{ enrollment.split(" ")[0] }}~{{
                  graduation.split(" ")[0]
                }}
              </div></el-tooltip
            >

            <el-tooltip :content="school" placement="top" v-if="school">
              <div class="normal-bottom-box-name">
                {{ $t("school") }}: {{ school }}
              </div></el-tooltip
            ><el-tooltip
              :content="profession"
              placement="top"
              v-if="profession"
            >
              <div class="normal-bottom-box-name">
                {{ $t("major") }}: {{ profession }}
              </div></el-tooltip
            >
          </div>
          <div class="normal-box">
            <div class="normal-top-box-name">{{ $t("languageSkills") }}</div>
            <el-tooltip :content="japanese" placement="top" v-if="japanese">
              <div class="normal-bottom-box-name">
                {{ $t("japanese") }} : {{ japanese }}
              </div></el-tooltip
            >
            <el-tooltip :content="english" placement="top" v-if="english">
              <div class="normal-bottom-box-name">
                {{ $t("english") }} : {{ english }}
              </div></el-tooltip
            ><el-tooltip :content="other" placement="top" v-if="other">
              <div class="normal-bottom-box-name">
                {{ $t("other") }}: {{ other }}
              </div></el-tooltip
            >
          </div>
        </div>
        <!--        第二行-->
        <div class="inline-normal-box">
          <div class="normal-box">
            <div class="normal-top-box-name">{{ $t("qualification") }}</div>
            <el-tooltip
              :content="qualification1"
              placement="top"
              v-if="qualification1"
            >
              <div class="normal-bottom-box-name">
                {{ qualification1 }}
              </div></el-tooltip
            ><el-tooltip
              :content="qualification2"
              placement="top"
              v-if="qualification2"
            >
              <div class="normal-bottom-box-name">
                {{ qualification2 }}
              </div></el-tooltip
            ><el-tooltip
              :content="other"
              qualification3="top"
              v-if="qualification3"
            >
              <div class="normal-bottom-box-name">
                {{ qualification3 }}
              </div></el-tooltip
            >
          </div>
          <div class="normal-box">
            <div class="normal-top-box-name">{{ $t("workHistory") }}</div>

            <el-tooltip
              :content="`${startYear.split(' ')[0]}~${endYear.split(' ')[0]}`"
              placement="top"
            >
              <div class="normal-bottom-box-name">
                {{ $t("period") }} :<span v-if="startYear">{{
                  startYear.split(" ")[0]
                }}</span
                >~<span v-if="endYear">{{ endYear.split(" ")[0] }}</span>
              </div></el-tooltip
            ><el-tooltip :content="workPlace" placement="top">
              <div class="normal-bottom-box-name">
                {{ $t("companyName") }} :{{ workPlace }}
              </div></el-tooltip
            ><el-tooltip :content="type" placement="top">
              <div class="normal-bottom-box-name">
                {{ $t("affiliation") }}: {{ type }}
              </div></el-tooltip
            >
          </div>
          <div class="normal-box">
            <div class="normal-top-box-name">{{ $t("request") }}</div>
            <el-tooltip
              :content="hopeEntryTime && hopeEntryTime.split(' ')[0]"
              placement="top"
            >
              <div class="normal-bottom-box-name">
                {{ $t("joinCompany") }}:<span v-if="hopeEntryTime">{{
                  hopeEntryTime.split(" ")[0]
                }}</span>
              </div></el-tooltip
            ><el-tooltip :content="hopeWorkplace" placement="top">
              <div class="normal-bottom-box-name">
                {{ $t("workLocation") }}: {{ hopeWorkplace }}
              </div></el-tooltip
            ><el-tooltip :content="hopeWorkType">
              <div class="normal-bottom-box-name">
                {{ $t("occupation") }}:{{ hopeWorkType }}
              </div></el-tooltip
            >
          </div>
        </div>
        <!--        第三行-->
        <div class="inline-normal-box">
          <div class="normal-box-3">
            <div class="normal-top-box-name-3">{{ $t("selfPR") }}</div>
            <div class="normal-bottom-box-name-3">
              {{ $t("occupation") }}:{{ pr }}
            </div>
          </div>
        </div>
      </div>
      <!--      button-->
      <div class="line-button-box">
        <button class="button-css1" @click="backClick">
          {{ $t("return") }}
        </button>
        <button class="button-css1" @click="saveClick" :disabled="isLock">
          {{ $t("temporarilySaved") }}
        </button>
        <button
          class="button-css2"
          @click="releaseTalentClick"
          :disabled="isLock1"
        >
          {{ $t("jobPosting") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { resumeAdd, resumeAddLaunch } from "../../js/api";

export default {
  name: "educationAdminTalentAdd3",
  components: {},
  data() {
    return {
      isLock: false,
      isLock1: false,
      avatar: "", //写真
      anonym: "", //假名-----1
      //就职担当
      name: "", //姓名------1
      sex: "", //性别---1
      telephone: "", //电话
      email: "", //邮箱
      address: "", //现居住地
      birth: "", //出生年月--1
      japanese: "", //日本语
      english: "", //英语
      other: "", //其他
      qualification1: "", //资格1
      qualification2: "",
      qualification3: "",
      pr: "", //自己pr--------1
      label1: 0,
      label2: 0,
      label3: 0,
      label4: 0,

      enrollment: "", //入学年月---2
      graduation: "", //毕业年月---2
      school: "", //学校----2
      profession: "", //专业---2
      startYear: "", //开始年月
      endYear: "", //结束年月
      workPlace: "", //工作地点
      type: "", //所属
      hopeWorkplace: "", //希望工作地点
      hopeEntryTime: "", //希望工作时间
      hopeWorkType: "", //希望工作类型
      hopeForm1: 0, //希望雇用形态1
      hopeForm2: 0, //
      hopeForm3: 0, //
      hopeForm4: 0, //
      hopeSalary: "", //希望工资
      startSalary: 0, //开始工资
      endSalary: 0, //结束工资
      otherHope: "", //其他希望

      education: "", //学历--？
      resumeId: "", //人才ID
      labelListHandle: [],
      avatarUrl: "",
      inputData1: "",
      inputData2: "",
      inputData3: "",
      inputData4: "",
      inputData5: "",
      inputData6: "",
      userId: ""
    };
  },
  created() {
    console.log(this.$route.params, "this.$route.params");
    this.avatar = this.$route.params.avatar;
    this.anonym = this.$route.params.anonym;
    this.name = this.$route.params.name;
    this.userId = this.$route.params.userId;
    this.sex = this.$route.params.sex;
    this.telephone = this.$route.params.telephone;
    this.email = this.$route.params.email;
    this.address = this.$route.params.address;
    this.birth = this.$route.params.birth;
    this.japanese = this.$route.params.japanese;
    this.english = this.$route.params.english;
    this.other = this.$route.params.other;
    this.qualification1 = this.$route.params.qualification1;
    this.qualification2 = this.$route.params.qualification2;
    this.qualification3 = this.$route.params.qualification3;
    this.pr = this.$route.params.pr;
    this.label1 = this.$route.params.label1;
    this.label2 = this.$route.params.label2;
    this.label3 = this.$route.params.label3;
    this.label4 = this.$route.params.label4;

    this.enrollment = this.$route.params.enrollment.split(" ")[0];
    this.graduation = this.$route.params.graduation.split(" ")[0];
    this.education = this.$route.params.education;
    this.school = this.$route.params.school;
    this.profession = this.$route.params.profession;
    this.startYear = this.$route.params.startYear.split(" ")[0];
    this.endYear = this.$route.params.endYear.split(" ")[0];
    this.workPlace = this.$route.params.workPlace;
    this.type = this.$route.params.type;
    this.hopeWorkplace = this.$route.params.hopeWorkplace;
    this.hopeEntryTime = this.$route.params.hopeEntryTime;
    this.hopeWorkType = this.$route.params.hopeWorkType;
    this.hopeForm1 = this.$route.params.hopeForm1;
    this.hopeForm2 = this.$route.params.hopeForm2;
    this.hopeForm3 = this.$route.params.hopeForm3;
    this.hopeForm4 = this.$route.params.hopeForm4;
    this.startSalary = this.$route.params.startSalary;
    this.endSalary = this.$route.params.endSalary;
    this.otherHope = this.$route.params.otherHope;
    this.inputData1 = this.$route.params.inputData1;
    this.inputData2 = this.$route.params.inputData2;
    this.inputData3 = this.$route.params.inputData3;
    this.inputData4 = this.$route.params.inputData4;
    this.inputData5 = this.$route.params.inputData5;
    this.inputData6 = this.$route.params.inputData6;
    this.avatarUrl = this.$route.params.avatarUrl;
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
      }
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.label1 = 1;
        this.labelListLength(1);
      } else if (num === 2) {
        this.label2 = 1;
        this.labelListLength(2);
      } else if (num === 3) {
        this.label3 = 1;
        this.labelListLength(3);
      } else if (num === 4) {
        this.label4 = 1;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("外国人歓迎") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("未経験 OK") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("新卒 OK") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("学歴問わない") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("外国人歓迎");
      } else if (num === 2) {
        this.labelListHandle.push("未経験 OK");
      } else if (num === 3) {
        this.labelListHandle.push("新卒 OK");
      } else if (num === 4) {
        this.labelListHandle.push("学歴問わない");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "外国人歓迎") {
            this.labelListHandle.splice(i, 1);
            this.label1 = 0;
            console.log("关闭 外国人歓迎 标签");
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "未経験 OK") {
            this.labelListHandle.splice(i, 1);
            this.label2 = 0;
            console.log("关闭 未経験 OK 标签");
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "新卒 OK") {
            this.labelListHandle.splice(i, 1);
            this.label3 = 0;
            console.log("关闭 新卒 OK 标签");
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "学歴問わない") {
            this.labelListHandle.splice(i, 1);
            this.label4 = 0;
            console.log("关闭 学歴問わない 标签");
          }
        }
      }
      console.log(this.labelListHandle);
    },
    //按鈕1-返回
    backClick() {
      console.log("button-戻る");
      this.$router.push({
        path: "/educationAdminTalentAddTwo",
        name: "educationAdminTalentAdd2"
      });
    },
    //按鈕2-一时保存
    saveClick() {
      console.log("button-一時保存");
      this.isLock = true;
      var fakeInfo = {
        avatar: this.avatar, //写真
        anonym: this.anonym, //假名-----1
        //就职担当
        name: this.name, //姓名------1
        userId: this.userId,
        sex: this.inputData1, //性别---1
        telephone: this.telephone, //电话
        email: this.email, //邮箱
        address: this.address, //现居住地
        birth: this.birth, //出生年月--1
        japanese: this.inputData2, //日本语
        english: this.inputData3, //英语
        other: this.other, //其他
        qualification1: this.qualification1, //资格1
        qualification2: this.qualification2,
        qualification3: this.qualification3,
        pr: this.pr, //自己pr--------1

        enrollment: this.enrollment, //入学年月---2
        graduation: this.graduation, //毕业年月---2
        education: this.inputData4, //学历--2
        school: this.school, //学校----2
        profession: this.profession, //专业---2
        startYear: this.startYear, //开始年月
        endYear: this.endYear, //结束年月
        workPlace: this.workPlace, //工作地点
        type: this.type, //所属
        hopeWorkplace: this.hopeWorkplace, //希望工作地点
        hopeEntryTime: this.hopeEntryTime, //希望工作时间
        hopeWorkType: this.inputData5, //希望工作类型
        hopeForm1: this.hopeForm1, //希望雇用形态1
        hopeForm2: this.hopeForm2, //
        hopeForm3: this.hopeForm3, //
        hopeForm4: this.hopeForm4, //
        hopeSalary: this.inputData6, //希望工资
        startSalary: this.startSalary, //开始工资
        endSalary: this.endSalary, //结束工资
        otherHope: this.otherHope, //其他希望
        resumeId: "" //人才ID
      };
      resumeAdd(fakeInfo).then(res => {
        console.log("人才信息添加保存接口");
        console.log(res);
        if (res.data.code === "A0000") {
          this.isLock = false;
          this.$message({
            message: this.$t("saveSuccess"),
            type: "success"
          });
          this.$router.push("/educationalInstitutionTalentListView");
        } else {
          this.$message.error(this.$t("saveFail"));
        }
      });
    },
    //按鈕3-人力资源张贴
    releaseTalentClick() {
      console.log(this.school, "button-人材掲載");
      this.isLock1 = true;
      var fakeInfo = {
        avatar: this.avatar || "", //写真
        anonym: this.anonym || "", //假名-----1
        //就职担当
        name: this.name || "", //姓名------1
        userId: this.userId || "",
        sex: this.inputData1 || "", //性别---1
        telephone: this.telephone || "", //电话
        email: this.email || "", //邮箱
        address: this.address || "", //现居住地
        birth: this.birth || "", //出生年月--1
        japanese: this.inputData2 || "", //日本语
        english: this.inputData3 || "", //英语
        other: this.other || "", //其他
        qualification1: this.qualification1 || "", //资格1
        qualification2: this.qualification2 || "",
        qualification3: this.qualification3 || "",
        pr: this.pr || "", //自己pr--------1

        enrollment: this.enrollment || "", //入学年月---2
        graduation: this.graduation || "", //毕业年月---2
        education: this.inputData4 || "", //学历--2
        school: this.school || "", //学校----2
        profession: this.profession || "", //专业---2
        startYear: this.startYear || "", //开始年月
        endYear: this.endYear || "", //结束年月
        workPlace: this.workPlace || "", //工作地点
        type: this.type || "", //所属
        hopeWorkplace: this.hopeWorkplace || "", //希望工作地点
        hopeEntryTime: this.hopeEntryTime || "", //希望工作时间
        hopeWorkType: this.inputData5 || "", //希望工作类型
        hopeForm1: this.hopeForm1 || "", //希望雇用形态1
        hopeForm2: this.hopeForm2 || "", //
        hopeForm3: this.hopeForm3 || "", //
        hopeForm4: this.hopeForm4 || "", //
        hopeSalary: this.inputData6 || "", //希望工资
        startSalary: this.startSalary || "", //开始工资
        endSalary: this.endSalary || "", //结束工资
        otherHope: this.otherHope || "", //其他希望

        resumeId: "" //人才ID
      };
      resumeAddLaunch(fakeInfo).then(res => {
        console.log("人才信息发布接口");
        console.log(res);
        if (res.data.code === "A0000") {
          this.isLock1 = false;
          this.$message({
            message: this.$t("releaseSuccess"),
            type: "success"
          });
          this.$router.push("/educationalInstitutionTalentListView");
        } else {
          this.$message.error(this.$t("releaseFail"));
        }
      });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  /* width: 1200px; */
  /* height: 100%; */
  margin: 0 auto;
  /* padding: 0 55px; */
  padding-bottom: 70px;
  box-sizing: border-box;
}
.top-title {
  height: 30px;
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  margin-top: 10px;
}
.progress-bar {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
.line-between-active {
  height: 2px;
  width: 80px;
  background: #51abff;
}
.line-between-normal {
  height: 2px;
  width: 80px;
  background: #dce3e9;
}
.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}
.progress-title {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -75px;
  display: block;
  height: 24px;
  width: 150px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #252a31;
}
.line-center-active {
  width: 160px;
  height: 2px;
  background: #51abff;
}
.line-center-normal {
  width: 160px;
  height: 2px;
  background: #dce3e9;
}
.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}

.inline-box {
  height: 130px;
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.one-box-left {
  width: 500px;
  height: 180px;
  padding-left: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.one-box-left1 {
  width: 350px;
  height: 70%;
  padding-left: 20px;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}
.one-box-left2 {
  width: 600px;
  height: 266px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}
.one-box-left-line1 {
  width: 100%;
  height: 5px;

  display: flex;
  justify-content: center;
  align-items: center;
}
.one-box-left-line2 {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.one-box-left-line3 {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.one-box-left-line4 {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.one-box-left-line-smallLeft {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 10px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}
.one-box-left-line-smallRight {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  /* or 143% */

  display: flex;
  align-items: center;
  letter-spacing: 0.25px;

  /* 灰色字体 */

  color: #686868;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}
.label-box span {
  display: inline-block;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.main-info-box {
  width: 100%;
  justify-content: center;
}
.inline-normal-box {
  width: 85%;
  background: #fff;
  display: flex;
  /* justify-content: center; */
  margin: 15px 0;
  padding-left: 10%;
}
.normal-box {
  width: 33%;
  box-sizing: border-box;
}
.normal-top-box-name {
  width: 200px;
  height: 25px;
  box-sizing: border-box;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  line-height: 25px;
  color: #686868;
}
.normal-bottom-box-name {
  width: 217px;
  height: 30px;
  font-weight: 400;
  font-size: 14px;
  line-height: 35px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.normal-box-3 {
  width: 75%;
  box-sizing: border-box;
}
.normal-top-box-name-3 {
  width: 75%;
  height: 25px;
  box-sizing: border-box;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  line-height: 25px;
  color: #686868;
}
.normal-bottom-box-name-3 {
  max-height: 140px;
  width: 75%;
  font-weight: 400;
  font-size: 14px;
  line-height: 35px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow-y: auto;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.button-css1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
.Avatar-img {
  width: 110px;
  height: 110px;
  background: #51abff;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
}
.mini-font {
  font-weight: 300;
  font-size: 8px;
  color: #686868;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationAdminTalentAdd3/index.vue